import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {RESERVATION_SENDING_CODE_LABEL} from "../constants/reservation_copy";
import {ReservationStepName} from "../types/ReservationStepName";

interface IReservationModalPropsParams {
    step: ReservationStepName;
    // the first code is on its way - the loader is shown without a title
    isInitiating: boolean;
    titleId: string;
    descriptionId: string;
}

// How the dialog of a host presents the reservation steps: named by the loader until the first code is on its way, closed by the overlay only on the confirmation
export const getReservationModalProps = (params: IReservationModalPropsParams) => {
    const {step, isInitiating, titleId, descriptionId} = params;

    const isConfirmed = step === "confirmed";
    const isLabelledByTitle = isConfirmed || !isInitiating;

    return {
        shouldCloseOnOverlayClick: isConfirmed,
        contentLabel: isLabelledByTitle ? undefined : RESERVATION_SENDING_CODE_LABEL,
        ariaLabelledBy: isLabelledByTitle ? titleId : undefined,
        ariaDescribedBy: isLabelledByTitle ? descriptionId : undefined,
        dataTestId: isConfirmed ? RP_RESERVATION_TEST_IDS.CONFIRMED_STEP : RP_RESERVATION_TEST_IDS.CODE_STEP
    };
};
import {RP_RESERVATION_TEST_IDS} from "@pg-mono/test-ids";

import {RESERVATION_SENDING_CODE_LABEL} from "../constants/reservation_copy";
import {ReservationStepName} from "../types/ReservationStepName";

interface IReservationModalPropsParams {
    step: ReservationStepName;
    // the first code is on its way - the loader is shown without a title
    isInitiating: boolean;
    titleId: string;
    descriptionId: string;
}

// How the dialog of a host presents the reservation steps: named by the loader until the first code is on its way, closed by the overlay only on the confirmation
export const getReservationModalProps = (params: IReservationModalPropsParams) => {
    const {step, isInitiating, titleId, descriptionId} = params;

    const isConfirmed = step === "confirmed";
    const isLabelledByTitle = isConfirmed || !isInitiating;

    return {
        shouldCloseOnOverlayClick: isConfirmed,
        contentLabel: isLabelledByTitle ? undefined : RESERVATION_SENDING_CODE_LABEL,
        ariaLabelledBy: isLabelledByTitle ? titleId : undefined,
        ariaDescribedBy: isLabelledByTitle ? descriptionId : undefined,
        dataTestId: isConfirmed ? RP_RESERVATION_TEST_IDS.CONFIRMED_STEP : RP_RESERVATION_TEST_IDS.CODE_STEP
    };
};
